import React, { useEffect, useState, useRef, useContext } from "react";
import Navbar from "../Navbar.jsx";
import Footer from "../Foooter.jsx";
import MenuStock from "../MenuStock.jsx";
import SearchBar from "../SearchBar.jsx";
import { StockContext } from "../../context/StockContext";
import "../../style/Stock.css";
import api from "../../utils/apiClient";
import FooterMovil from "../FooterMovil.jsx";

function Stock() {
  const [marcas, setMarcas] = useState([]);
  const [allmodelos, setAllModelos] = useState([]);
  const [reloadCont, setReload] = useState(false);

  const isMounted = useRef(true);
  const { openFilters } = useContext(StockContext);

  useEffect(() => {
    const fetchInitialData = async () => {
      await Promise.all([getMarcas(), getModelosAll()]);
    };
    fetchInitialData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  const getMarcas = async () => {
    try {
      const res = await api.get("marcasymodelos/marca");
      setMarcas(res.data.map((c) => c.Nombre));
    } catch (error) {
      console.error("Error fetching marcas:", error);
    }
  };

  const getModelosAll = async () => {
    try {
      const res = await api.get("marcasymodelos/modelo");
      setAllModelos(res.data.map((m) => m.Nombre));
    } catch (error) {
      console.error("Error fetching modelos:", error);
    }
  };

  return (
    <>
      <Navbar />
      <div className="stock-page">
        <SearchBar
          marcas={marcas}
          allmodelos={allmodelos}
          onCommit={() => setReload((v) => !v)}
        />

        <div className="stock-main">
          <MenuStock reload={reloadCont} activeOption={openFilters} />
        </div>
      </div>
      <div className="footer">
        <Footer />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default Stock;
